<template>
  <div class="edmodo-header">
    <header class="wrap clearfix">
      <h1 class="title fl">
        <!-- <a class="edmodo-a fl" :href="officialWebSite" >
          <img height="26" class="edmodo-logo" :src="logo" alt="edmodo">
        </a>
        <span class="labs fl">labs</span> -->
        <div v-if="isShowBack" class="header-back" @click="goBack">
          <i class="el-icon-arrow-left"></i>
        </div>
        <router-link to="/main">
          <img :src="logo" class="edmodo-logo" alt="EdmodoLabs">
        </router-link>
      </h1>
      <div class="nav-right fr clearfix">
        <header-search />
        <!-- 登录前 -->
        <a class="log login" href="javascript:;" v-if="!isLogin" @click="handleLogin">{{$t('txt_0002')}}</a>
        <!-- /登录前 -->
        <!-- 登录后 -->
        <!-- <div class="search-container" style="display: none">
          <input class="input" type="text" :placeholder="$t('txt_0024')">
        </div> -->
        <span class="signup user" v-if="isLogin">
          <img class="img-per-after fl" v-lazy="userLogo" alt="" />
          <span class="user-name fl"  :title="user_name">{{user_name}}</span>
        </span>
        <!--<span class="user-name fl"  v-if="isLogin" :title="user_name">{{user_name}}</span>-->
        <!-- /登录后 -->
      </div>
    </header>
  </div>
</template>

<script>
import { LOGIN_USER_INFO_KEY } from 'utils/constants'
import { THIRD_LOGIN_URL, LocalStorage } from 'utils/config'
import { FEEDBACK, EDMODO, EDMODO_SIGN_UP, EDMODO_SWITCH_ACCOUNT } from '../../constants/edmodo'

const logo = require('assets/Edmodo_Labs_Logo.png')
export default {
  name: 'edmodoHeader',
  data () {
    return {
      sonWindow: null,
      userInfo: {},
      logo,
      officialWebSite: EDMODO
    }
  },
  props: {
    isShowBack: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isLogin () {
      return this.userInfo.user_id
    },
    userLogo () {
      return {
        src: `https://cs.101.com/v0.1/static/cscommon/avatar/${this.userInfo.user_id}/${this.userInfo.user_id}.jpg?size=80`,
        error: 'images/img/el_portrait_default.png',
        loading: 'images/img/el_portrait_default.png'
      }
    },
    user_name () {
      return this.userInfo.user_name || this.userInfo.nick_name || '-'
    },
    loginUrl () {
      const location = window.location.href
      const url = THIRD_LOGIN_URL.url + location
      return url
    }
  },
  mounted () {
    this.init()
    this.getUserInfo()
  },
  methods: {
    init () {
      window.addEventListener('message', MessageObj => {
        if (MessageObj.data === 'login success') {
          if (this.sonWindow) {
            this.sonWindow.close()
            this.getUserInfo()
          }
        }
      })
    },
    getUserInfo () {
      const user = LocalStorage.get(LOGIN_USER_INFO_KEY) || {}
      this.userInfo = Object.assign({}, user)
    },
    handleFeedback () {
      const diva = document.createElement('a')
      const url = FEEDBACK
      diva.href = url
      diva.target = '_blank'
      document.body.appendChild(diva)
      diva.click()
      setTimeout(() => {
        document.body.removeChild(diva)
      }, 400)
    },
    switchAccount () {
      window.location.href = EDMODO_SWITCH_ACCOUNT
    },
    handleLogin () {
      if (window.gtag && this.isLogin) {
        window.gtag('event', 'edmodolabs_web_homepage001006002', {
          event_category: 'main',
          event_label: 'switch_account',
          event_callback: () => {
            console.log({
              event_id: 'edmodolabs_web_homepage001006002',
              event_category: 'main',
              event_label: 'switch_account'
            })
          }
        })
      }
      const protocol = location.protocol
      const host = location.host
      const url = protocol + '//' + host + '/#/third-login'
      this.sonWindow = window.open(url)
    },
    signup (identity) {
      const url = `${EDMODO_SIGN_UP}/${identity}-signup`
      window.location.href = url
    },
    logout () {
      if (window.gtag) {
        window.gtag('event', 'edmodolabs_web_homepage001006003', {
          event_category: 'main',
          event_label: 'quit',
          event_callback: () => {
            console.log({
              event_id: 'edmodolabs_web_homepage001006003',
              event_category: 'main',
              event_label: 'quit'
            })
          }
        })
      }
      // logout统一操作？
      localStorage.removeItem('L-ND-RES-LOGIN_USER_INFO_KEY')
      localStorage.removeItem('L-ND-RES-TOKENS')
      sessionStorage.removeItem('L-ND-RES-LOGIN_USER_INFO_KEY')
      sessionStorage.removeItem('L-ND-RES-TOKENS')
      window.location.reload()
    },
    goBack () {
      this.$router.go(-1)
    }
  },
  components: {
    headerSearch: () => import('./header/search')
  }
}
</script>

<style scoped>
.edmodo-header  {
  width: 100%;
  height: 60px; /*no*/
  background: #fff;
  padding: 0 6px;
  width: 100%;
  position: fixed;
  z-index: 9999;
  top: 0;
}
header {
  max-width: 1400px; /*no*/
  /* min-width: 768px; no */
  width: 100%;
  height: 100%;
  margin: 0 auto;
}
.title {
  display: flex;
  align-items: center;
  height: 100%;
}
.title .header-back {
  display: none;
}
.edmodo-a {
  height: 60px; /*no*/
}
.edmodo-logo {
  /* margin: 16px 0; */
  width: auto;
  height: 60px; /*no*/
}
.nav-right {
  display: flex;
  display: -webkit-flex;
  display: -webkit-box;
  display: -moz-box; 
  display: -ms-flexbox;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.labs {
  margin-left: 7px;
  color: #444444;
  font-family: VulfSans;
  font-size: 34px; /*no*/
  font-weight: 300;
  letter-spacing: -1px;
  text-align: left;
  line-height: 60px; /*no*/
}

.log {
  padding: 0 10px;
  text-align: center;
  line-height: 60px;  /*no*/
  background-color: #FFCA28;
  color: #1A237E;
  font-family: Disclaimer;
  font-size: 16px; /*no*/
  font-weight: 500;
  color:#1A237E;
}
.signup:hover {
  background: #fdd65f;
}
.login {
  line-height: 60px; /*no*/
  color: #636466;
  font-family: Disclaimer;
  font-size: 20px; /*no*/
  font-weight: 500;
  text-align: center; background: #fff;
}
.login:hover {
  background: #f8f9fb;
  color: #0d113f;
  color: #636466;
}
.signup {
  position: relative;
}
.user {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  padding: 0 10px;
  cursor: pointer;
  height: 60px; /*no*/
  line-height: 60px; /*no*/
}
.user:hover { background: #fff; }
.img-per-after {
  margin-right: 12px;
  width: 23px; /*no*/
  height: 23px; /*no*/
}
.user-name {
  font-size: 16px; /*no*/
}
@media only screen and ( max-width: 768px) {
  header {
    width: 100%;
  }
  .title .header-back {
    display: flex;
    align-items: center;
    width: 60px;
    height: 60px; /*no*/
  }
  .title .header-back i {
    font-size: 60px;
  }
  .user .user-name {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// header.vue?3cdb3184